import * as angular from 'angular';

import panelComponentDefinition from './panel.component';

import './style.less';

export const panel = angular.module('go.panel', [])
	.component('panel', panelComponentDefinition)
	.name;
